module.exports = __webpack_public_path__ + "img/stone2.eafd1ae1.png";